// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2aUDB","notes":"Notes_notes__2xFpF","note":"Notes_note__SWLF-","markdown":"Notes_markdown__1n3Uq"};